var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarouselTypologies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 24,
    viewBox: "0 0 73 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0498 19V5C21.0498 3.9 20.1498 3 19.0498 3H5.0498C3.9498 3 3.0498 3.9 3.0498 5V19C3.0498 20.1 3.9498 21 5.0498 21H19.0498C20.1498 21 21.0498 20.1 21.0498 19ZM8.5498 13.5L11.0498 16.51L14.5498 12L19.0498 18H5.0498L8.5498 13.5Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0498 19V5C45.0498 3.9 44.1498 3 43.0498 3H29.0498C27.9498 3 27.0498 3.9 27.0498 5V19C27.0498 20.1 27.9498 21 29.0498 21H43.0498C44.1498 21 45.0498 20.1 45.0498 19ZM32.5498 13.5L35.0498 16.51L38.5498 12L43.0498 18H29.0498L32.5498 13.5Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0496 6L56.6396 7.41L61.2196 12L56.6396 16.59L58.0496 18L64.0496 12L58.0496 6Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselTypologies);
export default __webpack_public_path__ + "static/media/carousel-typologies.ec3475ba8fffa0bf5d5237fa925fcfe5.svg";
export { ForwardRef as ReactComponent };